import React, { useState } from 'react';
import { Button, IconButton, Tooltip, TableCell } from '@material-ui/core';
import FileCopy from '@material-ui/icons/FileCopy';
import { useDispatch } from 'react-redux';
import { showMessage } from 'app/store/fuse/messageSlice';
import GenericInputActionDialog from 'app/admin/common/component/GenericInputActionDialog';
import TransformerTableService from '../service/TransformerTableService';

function CloneTransformerButton(props) {
	const [openDialog, setOpenDialog] = useState(false);

	const dispatch = useDispatch();

	const handleSend = (value) => {
		TransformerTableService.clone(props.item.id, value.name).then(response => { handleResponse(response) }).catch(err => handleError(err));
	};

	const handleResponse = (response) => {
		if (response.successful) {
			dispatch(showMessage({ message: 'Successfully cloned!' }));
			dispatch({ type: `${props.config.key}/event/setNeedDataReload` });
			setOpenDialog(false);
		} else {
			dispatch(showMessage({ message: 'Error!' }));
		}
	};

	const handleError = (error) => {
		dispatch(showMessage({ message: 'Error!' }));
	};

	return (
		<>

			{props.form ? <Button className='whitespace-nowrap mx-4' variant='contained' color='secondary' disabled={!props.item || !props.item.id} onClick={e => { setOpenDialog(true); e.preventDefault(); }} startIcon={<FileCopy className='hidden sm:flex' />}>
				Clone
			</Button> : <TableCell className='w-auto text-center' padding='none'>
				<Tooltip title='Clone'>
					<IconButton onClick={e => { setOpenDialog(true); e.preventDefault(); }}><FileCopy fontSize='small' /></IconButton>
				</Tooltip>
			</TableCell>}

			{openDialog && (
				<GenericInputActionDialog
					title='Clone'
					buttonLabel='Clone'
					// optimizationCase={props.item}
					defaultValues={{ name: props.item.name + ' - Clone' }}
					onCancel={() => setOpenDialog(false)}
					onSave={value => { handleSend(value); }}
				/>
			)}

		</>
	);
}

export default CloneTransformerButton;
